import { Divider, Flex, Image, Text } from "@fluentui/react-northstar";
import styled from "styled-components/macro";
import logo_yeetch from "../../../assets/logos/logo.svg";
import moment from "moment";
import { Container } from "../../../common/styles";
import { DEVICE } from "../../../constants/responsive";

const SCHeaderPreOnboarding = ({ arrival_date }) => {
    const formattedArrivalDate = moment(arrival_date).format("D MMMM YYYY");
    return (
        <Wrapper>
            <Container>
                <SFlexWrapperHeader fill>
                    <SFlexHeaderLeft gap="gap.medium" vAlign="center">
                        <SImage src={logo_yeetch} />
                        <Divider vertical fitted style={{ height: "18px" }} />
                        <SLogoText content="Votre espace RH" />
                    </SFlexHeaderLeft>
                    <SFlexHeaderRight>
                        <SChipDate vAlign="center" hAlign="center">
                            <STextDateLabel content="Date du premier jour" />
                            <STextDateValue content={formattedArrivalDate} />
                        </SChipDate>
                    </SFlexHeaderRight>
                </SFlexWrapperHeader>
            </Container>
        </Wrapper>
    );
};

export default SCHeaderPreOnboarding;

const SFlexWrapperHeader = styled(Flex)`
    justify-content: space-between;
    gap: 8px;
    @media ${DEVICE.mobileS} {
        flex-direction: column;
    }
    @media ${DEVICE.mobileL} {
        flex-direction: row;
    }
`;
const SFlexHeaderLeft = styled(Flex)``;
const SFlexHeaderRight = styled(Flex)``;

const STextDateLabel = styled(Text)`
    color: var(--text-tert);
`;
const STextDateValue = styled(Text)`
    font-weight: 700;
    color: var(--text);
    font-size: 14px;
`;

const SChipDate = styled(Flex)`
    gap: 10px;
    padding: 6px 14px;
    border: 1px solid var(--border);
    border-radius: 8px;
    font-size: 13px;
`;

const SLogoText = styled(Text)`
    font-size: 15px;
    color: var(--text-sec);
    margin-left: 4px;
`;

const SImage = styled(Image)`
    height: 25px;
`;

const Wrapper = styled(Flex)`
    background: white;
    border-bottom: 1px solid var(--border);
    height: 56px;
    display: flex;
    align-items: center;
    padding: 0 32px;
    gap: 16px;
    @media ${DEVICE.mobileS} {
        height: fit-content;
        padding: 16px;
    }
`;
